import React, { useEffect, useRef, useMemo } from 'react'
import { Row, Col } from 'antd'
import { LyricsInput } from 'components/LyricsInput'
import { KaraokeSlides } from 'components/KaraokeSlides'
import { Back } from 'components/BuildSteps/Back'
import { Next } from 'components/BuildSteps/Next'
import { ButtonContainer } from 'components/Button'
import { useKaraoke } from 'hooks/karaoke'
import { _EVENTS, useEventDispatch } from 'utils/EventEmitter'
import { useEventRecorder } from 'hooks/TimelineEvents'
import { LyricsView } from 'components/LyricsView/LyricsView'

export const PlaygroundSyncLyric = (props) => {
  const { audio, nextBuildStep } = useKaraoke()
  const { dispatchEvent: restartKaraoke } = useEventDispatch(
    _EVENTS.RESTART_KARAOKE
  )

  const audioRef = useRef()
  useEventRecorder({ audioRef })

  useEffect(() => {
    restartKaraoke()
  }, [])

  const counterProps = useMemo(() => ({ autoPlay: true }), [])
  const playerActions = useMemo(
    () => ({ play: () => audioRef.current.play() }),
    []
  )

  return (
    <>
      <Row gutter={16}>
        <Col className="small-canvas">
          <KaraokeSlides
            counterProps={counterProps}
            playerActions={playerActions}
          />
        </Col>
        <Col style={{ flex: 1, height: 416 }}>
          <LyricsView />
        </Col>
      </Row>

      <Row className="footer">
        <Col>
          <ButtonContainer>
            <Back />
          </ButtonContainer>
        </Col>
        <Col flex={1}>
          <audio
            controls
            className="form-audio"
            src={audio.src}
            ref={audioRef}
          />
        </Col>
        <Col>
          <ButtonContainer>
            <Next title="Preview" onClick={nextBuildStep} />
          </ButtonContainer>
        </Col>
      </Row>
    </>
  )
}
